export default "__VITE_PUBLIC_ASSET__cd0ef01a__"